import loadable from '@loadable/component';

export const InvalidLinkLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "InvalidLink" */
      './InvalidLink.dynamic'
    ),
);
